import React, { Component } from "react";
import JWPlayerOnScrollViewResize from "./JWPlayerOnScrollViewResize";
import { SeriesNav } from "./Series";
import {
  space2hyphen,
  space2hyphenForSlug,
  VideoCardDescription,
} from "./HelperFunctions";
import ReactJWPlayer from "react-jw-player";
import { Globals } from "./constants";
import axios from "axios";
import { Link } from "react-router-dom";
import { hyphen2space, getVideoPath } from "./HelperFunctions";
import { ToggleSwitch, Dropdown } from "./MatchVideos";
import BackgroundImage from "react-background-image-loader";
import { Helmet } from "react-helmet";
import Login from "./Login";

class SeriesVideos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      videoIndex: 0,
      seriesTitle: "",
      seriesVideosResp: {},
      videoId: this.props.match.params.videoId,
      seriesId: this.props.match.params.id,
      isVideoAllowed: this.props.isVideoAllowed,
      isRegionChecked: this.props.isRegionChecked,
      page: 1,
      pagesEnd: false,
      isLoading: true,
      filterBalls: false,
      tags: [],
      tag: 33,
      msisdn: "",
    };
    this.playerReady = this.playerReady.bind(this);
    this.playerError = this.playerError.bind(this);
    this.videoLoad = this.videoLoad.bind(this);
    this.nextVideoLoad = this.nextVideoLoad.bind(this);
    this.calendarSelect = this.calendarSelect.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.singleVideoCase = this.singleVideoCase.bind(this);
    this.tagChange = this.tagChange.bind(this);
    this.getTags = this.getTags.bind(this);
    this.isMobile = window.innerWidth < 992;
    this.getFromApi = this.getFromApi.bind(this);
    // if (!localStorage.getItem('user')) window.location.href = '/login';
    //if (!localStorage.getItem('user') && this.props.telco ==='mobilink') window.location.href = '/login';
  }

  async getTags() {
    const url =
      Globals.ApiUrl +
      "api/v2/user_api/get_tag_options_by_match?match_id=" +
      this.state.matchId +
      "&telco=" +
      this.props.telco +
      "&app_name=" +
      Globals.appName;
    try {
      const resp = await axios.get(url);
      const highlightsTag = resp.data.tags.filter(
        (obj) => obj.label.toLowerCase() === "highlights"
      );
      let filterBalls = false;
      if (
        highlightsTag[0].show_all === false &&
        highlightsTag[0].filter_balls === true
      ) {
        filterBalls = true;
      }
      this.setState(
        {
          tags: resp.data.tags,
          tag: highlightsTag[0].id,
          filterBalls: filterBalls,
        },
        () => this.getFromApi()
      );
    } catch (err) {
      console.log(err);
    }
  }

  tagChange(e) {
    e.persist();

    let html = e.target.innerHTML;
    const selectedTagId = e.target.id;
    document.getElementById("videos-selection").innerHTML = html;
    const selectedTag = this.state.tags.filter((obj) => obj.label === html);
    let filterBalls = false;
    if (
      selectedTag[0].show_all === false &&
      selectedTag[0].filter_balls === true
    ) {
      filterBalls = true;
    }
    this.setState(
      {
        page: 1,
        tag: selectedTagId,
        pagesEnd: false,
        filterBalls: filterBalls,
      },
      () => {
        this.getFromApi();
      }
    );
  }

  async getFromApi() {
    const url =
      Globals.ApiUrl +
      "api/v1/user_api/get_videos_by_series?series_id=" +
      this.props.match.params.id.toString() +
      "&page=" +
      this.state.page.toString() +
      "&tag_id=" +
      this.state.tag +
      "&per_page=10&telco=" +
      this.props.telco +
      "&app_name=" +
      Globals.appName;

    if (this.state.videoId) {
      this.singleVideoCase(this.state.videoId);
    } else {
      try {
        const resp = await axios.get(url);
        if (resp.status === 200) {
          this.setState({ seriesVideosResp: resp.data, isLoading: false });
          let elem = document.getElementsByClassName("none-message");
          if (elem.length > 0) {
            elem[0].classList.remove("d-none");
          }
        } else;
      } catch (err) {
        console.log(err);
      }
    }
  }

  likeUnlikeVideo() {}

  videoViewed() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.videoId !== this.props.match.params.videoId) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.singleVideoCase(nextProps.match.params.videoId);
    }
    const regionCheck = nextProps.isRegionChecked;
    this.setState({
      isVideoAllowed: nextProps.isVideoAllowed,
      isRegionChecked: regionCheck,
    });
    if (!this.state.isRegionChecked && regionCheck) {
      this.getTags();
    }
  }

  singleVideoCase(videoId) {
    const url =
      Globals.ApiUrl +
      "api/v1/user_api/get_videos_by_series?series_id=" +
      this.props.match.params.id.toString() +
      "&tag_id=" +
      this.state.tag +
      "&app_name=" +
      Globals.appName;

    const url2 =
      Globals.ApiUrl +
      "api/v1/user_api/get_single_video?id=" +
      videoId +
      "&telco=telco=" +
      this.props.telco +
      "&app_name=" +
      Globals.appName;

    const promise1 = new Promise((resolve) => {
      axios
        .get(url2)
        .then((res) => resolve(res))
        .catch((err) => resolve(err));
    });

    const promise2 = new Promise((resolve) => {
      axios
        .get(url)
        .then((res) => resolve(res))
        .catch((err) => resolve(err));
    });

    Promise.all([promise1, promise2])
      .then((resp) => {
        let singleVideo = [];
        singleVideo.push({ video: resp[0].data.video });
        const mergedVideos = singleVideo.concat(resp[1].data.videos);

        const mergedResponse = { ...resp[1].data, ...{ videos: mergedVideos } };

        this.setState({
          seriesVideosResp: mergedResponse,
          videoId: videoId,
          isLoading: false,
        });

        if (!this.state.isVideoAllowed) {
          alert(this.props.noVideoReason);
        }
      })
      .catch((err) => console.log(err));
  }

  async componentDidMount() {
    let isChecked = localStorage.getItem("autoplay");
    if (isChecked == 1) {
      this.setState({ isChecked: true });
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    let seriesTitle = this.props.match.params.title;
    this.setState({ seriesTitle: seriesTitle });

    if (this.state.isRegionChecked) this.getTags();

    let u = new URL(window.location);
    let src = u.searchParams.get("source");
    localStorage.setItem("source", src);
  }
  calendarSelect(e) {}
  /*playerReady(e) {
    if (!this.isMobile) JWPlayerOnScrollViewResize();
  }*/
  playerError(e) {
    if (!this.state.isVideoAllowed && !this.state.videoId) {
      alert(this.props.noVideoReason);
    }
  }
  videoLoad(e) {
    if (e.index !== 0) {
      const videosCopy = this.state.seriesVideosResp.videos.slice(
        1,
        this.state.seriesVideosResp.videos.length
      );
      this.setState({ seriesVideosResp: { videos: videosCopy } });
    }
  }

  nextVideoLoad(e) {
    let elem = document.getElementsByName("checkbox");
    if (elem) {
      elem = elem[0];
      if (elem.checked) {
        let videoIndex = this.state.videoIndex;
        let videoElem = document.getElementsByClassName("mvlist");
        if (videoElem[videoIndex]) {
          if (this.state.videoId !== "v") {
            let v = videoIndex + 1;
            this.setState({ videoIndex: v });
          }

          videoElem[videoIndex].click();
        }
      }
    }
  }

  async nextPage(e) {
    if (!this.state.pagesEnd) {
      let elem = document.getElementsByClassName("loading-more-results");
      if (elem.length) elem[0].classList.remove("d-none");

      const page = this.state.page + 1;
      const url =
        Globals.ApiUrl +
        "api/v1/user_api/get_videos_by_series?series_id=" +
        this.props.match.params.id.toString() +
        "&page=" +
        page.toString() +
        "&tag_id=" +
        this.state.tag +
        "&per_page=10&telco=" +
        this.props.telco +
        "&app_name=" +
        Globals.appName;

      let resp;
      try {
        resp = await axios.get(url);
      } catch (err) {
        console.log("error fetching next page");
      }

      if (resp.status === 200 && resp.data && resp.data.videos.length > 0) {
        if (elem.length) elem[0].classList.add("d-none");

        const moreVideos = this.state.seriesVideosResp.videos.concat(
          resp.data.videos
        );

        this.setState({ page: page, seriesVideosResp: { videos: moreVideos } });
      } else {
        if (elem.length) elem[0].classList.add("d-none");

        if (resp.data.length === 0 || !resp.data.videos.length)
          this.setState({ pagesEnd: true });
      }
    }
  }

  getUserPhone() {
    let user = localStorage.getItem("user");
    if (user) {
      this.setState({
        msisdn: user.phone,
      });
    }
  }

  render() {
    let series,
      videos = [],
      playlist = [],
      title = "",
      description = "",
      date = "",
      image = "";
    if (this.state.seriesVideosResp.hasOwnProperty("series")) {
      series = this.state.seriesVideosResp.series;
    }
    if (
      this.state.seriesVideosResp.hasOwnProperty("videos") &&
      this.state.seriesVideosResp.videos.length
    ) {
      videos = this.state.seriesVideosResp.videos;
      playlist = this.state.seriesVideosResp.videos.map(
        (obj) => (obj && obj.video ? { file: obj.video.video_file } : "")
      );
      title = videos[0].video ? videos[0].video.title : "";
      description = videos[0].video ? videos[0].video.match_desc : "";
      date = videos[0].video ? videos[0].video.created_at : "";
      image = videos[0].video ? videos[0].video.thumb_image : "";
    }

    return !localStorage.getItem("user") &&
      this.props.telco === "allavailable" ? (
      <Login />
    ) : (
      <section
        id="main-section"
        className="px-lg-0 jc-inner-page align-self-start"
      >
        <Helmet>
          <title>
            {hyphen2space(this.state.seriesTitle)} Videos - {Globals.product}
          </title>
          <meta
            name="description"
            content={
              "Check out the" +
              hyphen2space(this.state.seriesTitle) +
              " videos with the best coverage only on " +
              Globals.product
            }
          />
          <meta property="og:url" content={"Cricket!"} />
          <meta property="og:type" content="article" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image} />
          <meta property="twitter:card" content="summary_large_image" />
          <link
            rel="canonical"
            href={window.location.href.replace("www.", "")}
          />
        </Helmet>

        {this.state.isLoading ? (
          <div className="main-loader card min-height-80vh">
            <img width="64" height="64" src="/images/loader_v2.gif" alt="" />
          </div>
        ) : (
          <div />
        )}
        <div className="card p-3">
          <h4 className="text-uppercase font-weight-bold mb-2 mb-lg-3 pl-2 m-f-14">
            {hyphen2space(this.state.seriesTitle)}
          </h4>
          <SeriesNav path={this.props.match} />
        </div>
        <div className="card p-3 mt-2">
          {videos.length ? (
            <div>
              {/* <h4 className="text-uppercase mb-3">{(series) ? series.short_name : ''} </h4> */}
              <div className="player-container">
                <div className="player-position">
                  <ReactJWPlayer
                    playerId="player"
                    playerScript="https://content.jwplatform.com/libraries/IDzF9Zmk.js"
                    // playlist={playlist}
                    file={
                      this.state.isVideoAllowed
                        ? videos[0].video
                          ? getVideoPath(videos[0].video)
                          : ""
                        : ""
                    }
                    onReady={this.playerReady}
                    onVideoLoad={this.videoLoad}
                    onOneHundredPercent={this.nextVideoLoad}
                    onSetupError={this.playerError}
                  />
                </div>
              </div>

              <div className="px-2 pt-3 pb-0 d-flex ">
                <VideoCardDescription
                  title={title}
                  description={description}
                  date={date}
                  showDescription={true}
                  showDate={true}
                />
              </div>
              {videos.length ? (
                <div className="d-flex">
                  <div className="ml-auto navbar-expand">
                    <ul className="navbar-nav mt-2 mt-lg-0">
                      <li className="nav-item">
                        <a
                          data-original-title="Facebook"
                          className="nav-link text-secondary h4 mb-0 py-0 m-f-14"
                          target="_blank"
                          href={
                            "https://www.facebook.com/sharer/sharer.php?u=" +
                            window.location.href
                          }
                        >
                          <i className="fa fa-facebook" />
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          data-original-title="twitter"
                          className="nav-link text-secondary h4 mb-0 py-0 m-f-14"
                          href={
                            "http://www.twitter.com/share?text=" +
                            title +
                            "&amp;url=" +
                            window.location.href +
                            "/"
                          }
                        >
                          <i className="fa fa-twitter" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              ) : (
                <div />
              )}
              <div className="text-right d-flex mb-3">
                <Dropdown
                  tags={this.state.tags}
                  tagChange={this.tagChange}
                  defaultSelect="Highlights"
                />
              </div>
              {videos.map(
                (obj, i) =>
                  i !== 0 &&
                  (!this.state.filterBalls ||
                    (this.state.filterBalls && obj.ball)) ? (
                    <Link
                      to={
                        "/series/" +
                        this.props.match.params.id +
                        "/" +
                        this.state.seriesTitle +
                        "/videos/" +
                        obj.video.id +
                        "/" +
                        space2hyphenForSlug(obj.video.title)
                      }
                      key={"sv-" + i}
                      className="d-flex p-2 mvlist"
                    >
                      <div className="w-30 pr-3 position-relative">
                        <BackgroundImage
                          className="sixteen-by-nine bg-center-cover"
                          src={obj.video.thumb}
                          placeholder={Globals.placeholderPlain4x3}
                        >
                          <div className="fa fa-play-circle play-btn-lg play-btn-sm" />
                        </BackgroundImage>
                        {/* <div className="sixteen-by-nine bg-center-cover" style={{backgroundImage: "url(" + obj.video.thumb + ")"}}></div> */}
                      </div>
                      <VideoCardDescription
                        title={obj.video.title}
                        description={obj.video.match_desc}
                        showDescription={true}
                        showDate={true}
                      />
                    </Link>
                  ) : (
                    <div key={"sv-" + i} />
                  )
              )}
            </div>
          ) : (
            <h5 className="mb-0 none-message d-none">
              Videos not available at the moment
            </h5>
          )}
        </div>
        {!this.state.pagesEnd && videos.length ? (
          <div>
            <div className="text-center d-none loading-more-results">
              <img src="/images/loader_v2.gif" alt="" height="30" />
            </div>
            <button
              id="more-results"
              onClick={this.nextPage}
              type="button"
              className="btn btn-primary d-none"
            >
              More Results
            </button>
          </div>
        ) : (
          <div />
        )}
      </section>
    );
  }
}

export default SeriesVideos;
